import { actions } from '../../../../utils/constants';

export const fetchAdminData = () => ({
    type: actions.ASYNC_FETCH_ADMIN_DATA,
});

export const updateCourse = (courseId, value) => ({
    type: actions.UPDATE_COURSE,
    payload: {
        courseId,
        value,
    },
});



// WEBPACK FOOTER //
// ./src/components/internal-pages/components/admin-pages/admin-pages.actions.js